import { CONST } from "../sideTypes"
import { MenuItemCategory, MenuItemType, PopupPageId, ProvincesShortCode, ScreenActions } from "../../Components/navigationTypes"
import { PRODUCT_NAME } from "../../Components/branding"




export const getDetailsList: (appCode: ProvincesShortCode, sid: string, isCollege: boolean) => Promise<Array<MenuItemType>> =
    async (appCode, sid, isCollege) => {
        const Basic: MenuItemType = {
            label: "Basic",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    compat: "1",
                    formasp: "purfileedit",
                    id: CONST.uninitialized,
                    tb: "TPAppXML",
                },
                controller: {
                    tabName: "Basic",
                    tabNumber: 0,
                },
            },
            addOptions: [],
            type: MenuItemCategory.TopLevel,
            icon: "fa-info-square"
        }

        const Contract: MenuItemType = {
            label: "Contract",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "tb": "TPAppXML",
                    "formasp": "purfileedit",
                    "id": CONST.uninitialized,
                    "PSM": CONST.uninitialized,
                },
                controller: {
                    tabName: "Basic",
                    tabNumber: 2,
                },
            },
            PSM: "PSO",
            addOptions: [],
            type: MenuItemCategory.TopLevel,
            icon: "fa-file-music",
        }

        const Property: MenuItemType = {
            label: "Property",
            appCode: ["RPW", "RPWSK", "RPWNS", "RPWAB", "RPWMB"],
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "tb": "TPAppXML",
                    "formasp": "purfileedit",
                    "id": CONST.uninitialized,
                    "PSM": CONST.uninitialized,
                },
                controller: {
                    tabName: "Basic",
                    tabNumber: 1,
                },
            },
            addOptions: [],
            type: MenuItemCategory.Property,
            icon: "fa-warehouse",
        }

        const ExtraProperty: MenuItemType =  {
            label: "Property",
            appCode: ["RPWBC"],
            PSM: "PSM",
            navigate: {
                component: "main",
            },
            addOptions: [],
            subItems: [
                {
                    label: "Property Details",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Basic",
                            tabNumber: 1,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Extra Properties",
                    PSM: "PSM",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Basic",
                            tabNumber: 1,
                            autoClick: "ExtraProperties"
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default

                }
            ],
            expandable: true,
            type: MenuItemCategory.Heading,
            icon: "fa-warehouse",
        }

        const Buyer: MenuItemType =
        {
            id: "Buyer",
            label: "Buyer Side",
            PSM: "PSOM",
            navigate: {
                component: "main",
            },
            addOptions: [
                {
                    label: "Individual",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: PopupPageId.Transferee,
                            tabNumber: -1,
                            screenAction: ScreenActions.setTransferIndividual,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Corporation",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: PopupPageId.Transferee,
                            tabNumber: -1,
                            screenAction: ScreenActions.setTransferCorporation,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Estate",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: PopupPageId.Transferee,
                            tabNumber: -1,
                            screenAction: ScreenActions.setTransferEstate,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
            ],
            expandable: true,
            type: MenuItemCategory.Heading,
            icon: "fa-user-plus",
        };

        const Issues: MenuItemType =
        {
            id: "Issues",
            label: "Issues",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "tb": "TPAppXML",
                    "formasp": "purfileedit",
                    "id": CONST.uninitialized,
                    "PSM": CONST.uninitialized,
                },
                controller: {
                    tabName: "Issues",
                    tabNumber: 0,
                    // autoClick: "SearchIssues",
                },
                //action: "AddNewDefectSearch"
            },
            // subItems: [
            //     {
            //         label: "All Issues",
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 0,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            //     {
            //         label: "Response to Undertaking",
            //         PSM: "S",
            //         appCode: ["RPWBC"],
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 1,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            //     {
            //         label: "Undertaking",
            //         PSM: "PM",
            //         appCode: ["RPWBC"],
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 1,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            //     {
            //         label: "Checklist",
            //         appCode: ["RPW", "RPWAB", "RPWMB", "RPWNS", "RPWSK"],
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 3,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            //     {
            //         label: "Checklist",
            //         appCode: ["RPWBC"],
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 2,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            //     {
            //         label: "Inquiry Status",
            //         appCode: ["RPW", "RPWAB", "RPWMB", "RPWNS", "RPWSK"],
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 1,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            //     {
            //         label: "Inquiry Status",
            //         appCode: ["RPWBC"],
            //         PSM: "PM",
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 3,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            //     {
            //         label: "Objection",
            //         appCode: ["RPWNS"],
            //         PSM: "PM",
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 2,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            //     {
            //         label: "Description",
            //         appCode: ["RPWAB"],
            //         PSM: "PM",
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 2,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            //     {
            //         label: "Requisition",
            //         PSM: "P",
            //         appCode: ["RPW"],
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 2,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            //     {
            //         label: "Report",
            //         PSM: "PS",
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 4,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            //     {
            //         label: "Report",
            //         PSM: "M",
            //         appCode: ["RPWNS"],
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 4,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            //     {
            //         label: "Response Items",
            //         appCode: ["RPWAB"],
            //         PSM: "S",
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 2,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            //     {
            //         label: "Response to Requisition",
            //         appCode: ["RPW"],
            //         PSM: "S",
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 2,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            //     {
            //         label: "Title Memorandum",
            //         PSM: "M",
            //         appCode: ["RPW", "RPWSK", "RPWAB", "RPWMB"],
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 4,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            //     {
            //         label: "Trust Letter",
            //         appCode: ["RPWMB"],
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 2,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            //     {
            //         label: "Trust Letter",
            //         PSM: "S",
            //         appCode: ["RPWSK"],
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 2,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            //     {
            //         label: "Trust Letter Reconciliation",
            //         PSM: "P",
            //         appCode: ["RPWSK"],
            //         navigate: {
            //             component: "main",
            //             url: "lfmaster.asp",
            //             params: {
            //                 "tb": "TPAppXML",
            //                 "formasp": "purfileedit",
            //                 "id": CONST.uninitialized,
            //                 "PSM": CONST.uninitialized,
            //             },
            //             controller: {
            //                 tabName: "Issues",
            //                 tabNumber: 2,
            //             },
            //         },
            //         addOptions: [],
            //         type: MenuItemCategory.Default
            //     },
            // ],
            addOptions: [],
            type: MenuItemCategory.TopLevel,
            // maxSize: 0,
            // expandable: true,
            icon: "fa-square-check",
        };

        const Seller: MenuItemType =
        {
            id: "Seller",
            label: "Seller Side",
            PSM: "PSO",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "formxml": "TransferorDetails",
                    "diagData": "1",
                    "tabNum": String(0)
                }
            },
            addOptions: [
                {
                    label: "Individual",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: PopupPageId.Transferor,
                            tabNumber: -1,
                            screenAction: ScreenActions.setTransferIndividual,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Corporation",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: PopupPageId.Transferor,
                            tabNumber: -1,
                            screenAction: ScreenActions.setTransferCorporation,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Estate",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: PopupPageId.Transferor,
                            tabNumber: -1,
                            screenAction: ScreenActions.setTransferEstate,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
            ],
            expandable: true,
            type: MenuItemCategory.Heading,
            icon: "fa-user-minus"
        };

        const ThirdParty: MenuItemType =
        {
            id: "Third",
            label: "Additional Parties",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
            },
            addOptions: [
                {
                    label: "Buying Agent",
                    PSM: "PS",
                    appCode: ["RPWAB"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'RealEstateBroker'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Conveyancer",
                    appCode: ["RPW"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'Conveyancer'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Fire Insurance",
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'FireInsurer',
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Mortgage Broker",
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'MortgageBroker'
                        }
                    },
                    PSM: "PM",
                    appCode: ["RPW"],
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Real Estate Broker",
                    PSM: "PS",
                    appCode: ["RPW"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'RealEstateBroker'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Real Estate Agent - Purchaser",
                    PSM: "PS",
                    appCode: ["RPWSK", "RPWMB"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'PurchaserRealEstateBroker'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Real Estate Agent - Vendor",
                    PSM: "PS",
                    appCode: ["RPWSK", "RPWMB"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'RealEstateBroker'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Real Estate Agent - Purchaser",
                    PSM: "S",
                    appCode: ["RPWNS"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'PurchaserRealEstateBroker'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Real Estate Agent - Vendor",
                    PSM: "S",
                    appCode: ["RPWNS"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'RealEstateBroker'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Listing Agent",
                    PSM: "PS",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'RealEstateBroker'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Selling Agent",
                    PSM: "PS",
                    appCode: ["RPWAB", "RPWBC"],
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: 'PurchaserRealEstateBroker'
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Relocation Company",
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: "OtherParty",
                            onClickDispatchPayload: {
                                filterType: "Relocation Company"
                            }
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Referral",
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: "OtherParty",
                            onClickDispatchPayload: {
                                filterType: "Referral"
                            }
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Water Company",
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: 'Basic',
                            onClickDispatch: "OtherParty",
                            onClickDispatchPayload: {
                                filterType: "Water Company"
                            }
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
            ],
            expandable: true,
            type: MenuItemCategory.Heading,
            icon: "fa-people-group",
        };

        const Financial: MenuItemType =
        {
            label: "Financial",
            navigate: {
                component: "main"
            },
            subItems: [
                {
                    label: "Statement of Adjustments",
                    appCode: ["RPW", "RPWAB", "RPWMB", "RPWNS", "RPWSK"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 0,
                        },
                    },
                    PSM: "PS",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Vendor Adjustments",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 0,
                        },
                    },
                    PSM: "S",
                    TitleTransferExclude: true,
                    addOptions: [],
                    type: MenuItemCategory.Default,
                    requiredFields: [{ field: "getLawyerShowSellerAdjustmentsNew", value: "1" }],
                },
                {
                    label: "Vendor Adjustments",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 0,
                        },
                    },
                    PSM: "P",
                    TitleTransferExclude: true,
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Purchaser Adjustments",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 1,
                        },
                    },
                    PSM: "P",
                    TitleTransferExclude: true,
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Account to Client - Interim",
                    PSM: "P",
                    appCode: ["RPW"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": "P",
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 5,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default,
                    requiredFields: [
                        {
                            field: "getPropertyType",
                            value: "Condo"
                        },
                        {
                            field: "getInterimClosingDate"
                        },
                        {
                            field: "getNewHome",
                            value: "0"
                        }

                    ]
                },
                {
                    label: "Account to Client",
                    appCode: ["RPWAB"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 1,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Account to Client",
                    appCode: ["RPW", "RPWNS", "RPWSK", "RPWMB"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 2,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Trust In/Out",
                    appCode: ['RPWBC'],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 2,
                        },
                    },
                    PSM: "PSM",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: `${PRODUCT_NAME} Ledger`,
                    appCode: ['RPWBC'],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        reactFrame: 'trustshield',
                        controller: {
                            tabName: "Financial",
                        },
                    },
                    PSM: "PSM",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                    requiredFields: [{ field: "getLawyerTrustShield", value: "1" }],
                },
                {
                    label: "Account to Client",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 3,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Trust Statement",
                    appCode: ["RPW", "RPWNS"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 3,
                        },
                    },
                    PSM: "PSM",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Deed Transfer Tax",
                    appCode: ["RPWNS"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 1,
                        },
                    },
                    PSM: "PO",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Land Transfer Tax",
                    appCode: ["RPW"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 1,
                        },
                    },
                    PSM: "PO",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Estimated Closing Costs",
                    appCode: ['RPWMB'],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 1,
                        },
                    },
                    PSM: "P",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Estimated Purchaser's Adjustments",
                    appCode: ['RPWSK'],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 3,
                        },
                    },
                    PSM: "P",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Estimated Vendor's Adjustments",
                    appCode: ['RPWSK'],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 3,
                        },
                    },
                    PSM: "S",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Estimated Mortgagor's Adjustments",
                    appCode: ['RPWSK'],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 3,
                        },
                    },
                    PSM: "M",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Closing Funds Summary",
                    appCode: ["RPWAB"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 3,
                        },
                    },
                    PSM: "PSM",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Closing Funds Summary",
                    appCode: ["RPW"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 4,
                        },
                    },
                    PSM: "PSM",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Trust Statement",
                    appCode: ["RPWMB"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 4,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Trust Statement",
                    appCode: ['RPWAB'],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 2,
                        },
                    },
                    PSM: "PSM",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Purchaser's Adjustments",
                    appCode: ["RPWSK"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 4,
                        },
                    },
                    PSM: "P",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Vendor's Adjustments",
                    appCode: ["RPWSK"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 4,
                        },
                    },
                    PSM: "S",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Mortgagor's Adjustments",
                    appCode: ["RPWSK"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Financial",
                            tabNumber: 4,
                        },
                    },
                    PSM: "M",
                    addOptions: [],
                    type: MenuItemCategory.Default,
                },
                {
                    label: "Soluno Export",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        reactFrame: 'solunoexport',
                        controller: {
                            tabName: "Financial",
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default,
                    requiredFields: [{ field: "getLawyerSoluno", value: "1" }],
                },
            ],
            addOptions: [],
            expandable: true,
            type: MenuItemCategory.Heading,
            icon: "fa-dollar-sign",
        };

        const Mortgage: MenuItemType =
        {
            label: "Mortgage",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "formxml": "purmort",
                    "tb": "TPAppXML",
                    "id": CONST.uninitialized,
                    "PSM": CONST.uninitialized,
                    "tabNum": String(0),
                }
            },
            addOptions: [
                {
                    label: "Import",
                    id: "ImportRenai",
                    icon: 'renai-icon renai-icon-light',
                    navigate: {
                        component: "main",
                        controller: {
                            onClickDispatch: "MortgageDropbox",
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default,
                    newBadge: true,
                    // userJSON: "AI",
                },
                {
                    label: 'Inbox & LLC',
                    PSM: "PM",
                    navigate: {
                        component: "main",
                        popup: true,
                        isModal: true,
                        reactModalFrame: "mortimp",
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: 'Lender Centre',
                    PSM: "PM",
                    navigate: {
                        component: "main",
                        controller: {
                            tabName: "Mortgages",
                            tabNumber: 0,
                            autoClick: "openLenderCentre",
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "New Standard",
                    navigate: {
                        component: "main",
                        controller: {
                            onClickDispatch: "MortgageLender",
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Assume",
                    appCode: ["RPW", "RPWAB", "RPWMB", "RPWNS"],
                    PSM: "PS",
                    navigate: {
                        component: "main",
                        action: "AddNewMatter3",
                        actionParam: "32_1",
                        controller: {
                            tabName: "Mortgages",
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Discharge",
                    appCode: ["RPW", "RPWAB", "RPWMB", "RPWNS"],
                    navigate: {
                        component: "main",
                        action: "AddNewMatter3",
                        actionParam: "32_2",
                        controller: {
                            tabName: "Mortgages",
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Existing Mortgage",
                    appCode: ["RPWBC", "RPWSK"],
                    navigate: {
                        component: "main",
                        action: "AddNewMatter4",
                        actionParam: null,
                        controller: {
                            tabName: "Mortgages",
                        }
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Vendor Take Back",
                    PSM: "PS",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Mortgages",
                            tabNumber: -1,
                            screenAction: ScreenActions.setVTB,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                }

            ],
            expandable: true,
            type: MenuItemCategory.Heading,
            icon: "fa-building-columns",
        };

        const Workspace: MenuItemType = {
            label: "Due Diligence",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
            },
            subItems: [
                {
                    label: "Property Online",
                    appCode: ["RPWNS"],
                    navigate: {
                        component: "",
                        url: "http://novascotia.ca/sns/access/land/property-online.asp",
                    },
                    addOptions: [],
                    type: MenuItemCategory.WindowOpen,
                },
                {
                    label: "ISC Property Search",
                    appCode: ["RPWSK"],
                    navigate: {
                        component: "",
                        url: "https://www.saskregistries.ca/#onlineservices",
                    },
                    addOptions: [],
                    type: MenuItemCategory.WindowOpen,
                },
                {
                    label: "LTSA",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Basic",
                            tabNumber: 0,
                            autoClick: "LTSAButton"
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.TitleInsurance
                },
                {
                    label: "Manufactured Home",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Basic",
                            tabNumber: 0,
                            autoClick: "ManufacturedHomeButton"
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.TitleInsurance
                },
                {
                    label: "First Nations Land",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Basic",
                            tabNumber: 0,
                            autoClick: "FirstNationsLandButton"
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.TitleInsurance
                },
                {
                    label: "Archived Searches",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Basic",
                            tabNumber: 0,
                            autoClick: "oldSearch"
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.TitleInsurance
                },
                {
                    label: "Similar Names",
                    appCode: ["RPW", "RPWAB", "RPWNS"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 0,
                        },
                        reactFrame: 'similiarnames',
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "SPIN2",
                    appCode: ["RPWAB"],
                    navigate: {
                        component: "",
                        url: "https://alta.registries.gov.ab.ca/spinii/logon.aspx",
                    },
                    addOptions: [],
                    type: MenuItemCategory.WindowOpen,
                },
                {
                    label: "Tax Search",
                    appCode: ["RPWSK"],
                    navigate: null,
                    addOptions: [],
                    type: MenuItemCategory.Dropdown,
                    dropdownOptions: [
                        {
                            label: "Moose Jaw",
                            navigate: {
                                component: "",
                                url: "https://moosejaw.ca/property-tax-assessment-search/",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                        {
                            label: "Regina",
                            navigate: {
                                component: "",
                                url: "http://www.regina.ca/residents/assessment/tax-property-search",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                        {
                            label: "Saskatoon",
                            navigate: {
                                component: "",
                                url: "https://www.saskatoon.ca/services/property-tax-searches-certificates",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                    ]
                },
                {
                    label: "Tax Search",
                    appCode: ["RPW"],
                    navigate: null,
                    addOptions: [],
                    type: MenuItemCategory.Dropdown,
                    dropdownOptions: [
                        {
                            label: "Burlington",
                            navigate: {
                                component: "",
                                url: "https://www.burlington.ca/en/property-taxes/tax-certificates.aspx",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                        {
                            label: "Cambridge",
                            navigate: {
                                component: "",
                                url: "https://online.cambridge.ca/WaterService/taxinfo.aspx",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                        {
                            label: "Markham",
                            navigate: {
                                component: "",
                                url: "https://www.markham.ca/permits-licences-taxes/property-taxes/tax-account-changes/tax-certificate-purchase-form",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                        {
                            label: "Mississauga",
                            navigate: {
                                component: "",
                                url: "https://www.mississauga.ca/portal/services/purtaxcertificate",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                        {
                            label: "Oakville",
                            navigate: {
                                component: "",
                                url: "http://www.oakville.ca/residents/taxes-statements.html",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                        {
                            label: "Ottawa",
                            navigate: {
                                component: "",
                                url: "https://myservice.ottawa.ca/profile/account/login?lang=en",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                        {
                            label: "Peterborough",
                            navigate: {
                                component: "",
                                url: "https://mytaxportal.peterborough.ca/taxinfo",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                        {
                            label: "Toronto",
                            navigate: {
                                component: "",
                                url: "https://www.toronto.ca/services-payments/property-taxes-utilities/tax-utility-certificate-service/",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                        {
                            label: "Windsor Tax Search",
                            navigate: {
                                component: "",
                                url: "https://etinew.citywindsor.ca/",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                        {
                            label: "Windsor Tax Assessment",
                            navigate: {
                                component: "",
                                url: "https://publicpropertyinquiry.citywindsor.ca/",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                    ],
                },
                {
                    label: "Tax Search",
                    appCode: ["RPWAB"],
                    navigate: null,
                    addOptions: [],
                    type: MenuItemCategory.Dropdown,
                    dropdownOptions: [
                        {
                            label: "Calgary",
                            navigate: {
                                component: "",
                                url: "https://cityonline.calgary.ca/col_ccu/property-information/5637145378.c",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                        {
                            label: "Edmonton",
                            navigate: {
                                component: "",
                                url: "http://taxcertificates.edmonton.ca/",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                        {
                            label: "Lethbridge",
                            navigate: {
                                component: "",
                                url: "https://ecom.lethbridge.ca/MyCity/PIP/Pages/Login.aspx?templateName=DEFAULT",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                        {
                            label: "Medicine Hat",
                            navigate: {
                                component: "",
                                url: "https://www1.medicinehat.ca/login.aspx",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                        {
                            label: "Okotoks",
                            navigate: {
                                component: "",
                                url: "https://vth.okotoks.ca/default.aspx",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                        {
                            label: "Redcliff",
                            navigate: {
                                component: "",
                                url: "https://my.townofredcliff.ca:8443/VCH/city/mycity/login.aspx?ReturnUrl=%2fVCH%2fcity%2fmycity%2fmycity.aspx",
                            },
                            addOptions: [],
                            type: MenuItemCategory.WindowOpen,
                        },
                    ],
                },
                {
                    label: "Tax Search",
                    appCode: ["RPWMB"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Basic",
                            tabNumber: 0,
                            autoClick: "TaxSearchButton",
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Title Search",
                    appCode: ["RPW"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Basic",
                            tabNumber: 3,   
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Writ Search",
                    appCode: ["RPW"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Basic",
                            tabNumber: 4,
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Title Search",
                    appCode: ["RPWSK", "RPWNS", "RPWAB", "RPWMB"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Basic",
                            tabNumber: 0,
                            autoClick: "TitleSearchButton",
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
            ],
            addOptions: [],
            expandable: true,
            type: MenuItemCategory.Heading,
            icon: "fa-magnifying-glass"
        };

        const Title: MenuItemType =     {
            label: "Title Insurance",
            PSM: "PM",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "tb": "TPAppXML",
                    "formasp": "purfileedit",
                    "id": CONST.uninitialized,
                    "PSM": CONST.uninitialized,
                },
                controller: {
                    tabName: "Title Insurance",
                },
            },
            addOptions: [],
            type: MenuItemCategory.TopLevel,
            icon: "fa-file-certificate",
        };

        const Fire: MenuItemType = {
            id: "FireInsurance",
            label: "Fire Insurance",
            PSM: "PMS",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "tb": "TPAppXML",
                    "formasp": "purfileedit",
                    "id": CONST.uninitialized,
                    "PSM": CONST.uninitialized,
                },
                controller: {
                    tabName: "Fire Insurance",
                },
            },
            addOptions: [],
            type: MenuItemCategory.TopLevel,
            icon: "fa-fire"
        };

        const Requisition: MenuItemType = {
            id: "Requisition",
            label: "Requisition",
            appCode: ["RPW"],
            PSM: "PS",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "tb": "TPAppXML",
                    "formasp": "purfileedit",
                    "id": CONST.uninitialized,
                    "PSM": CONST.uninitialized,
                },
                controller: {
                    tabName: "Issues",
                    tabNumber: 2,
                },
            },
            addOptions: [],
            type: MenuItemCategory.TopLevel,
            icon: "fa-arrow-right-arrow-left",
        }

        const Undertaking: MenuItemType = {
            id: "Undertaking",
            label: "Undertaking",
            appCode: ["RPWBC"],
            PSM: "PSM",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "tb": "TPAppXML",
                    "formasp": "purfileedit",
                    "id": CONST.uninitialized,
                    "PSM": CONST.uninitialized,
                },
                controller: {
                    tabName: "Issues",
                    tabNumber: 1,
                },
            },
            addOptions: [],
            type: MenuItemCategory.TopLevel,
            icon: "fa-arrow-right-arrow-left"
        }
        
        const RegistrationHeading: MenuItemType = {
            id: "reg_sub",
            label: "Registration",
            appCode: ["RPW", "RPWBC", "RPWMB", "RPWAB"],
            navigate: {
                component: "main",
                url: "lfmaster.asp",
            },
            subItems: [
                {
                    label: "Registration Details",
                    appCode: ["RPW", "RPWAB", "RPWSK"],
                    navigate: {
                        component: "main",
                        action: "PopUpRegistrationDetails"
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Teranet",
                    appCode: ["RPWMB"],
                    navigate: {
                        component: "main",
                        action: "openTeranetPopup",
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "PIPS",
                    appCode: ["RPW"],
                    PSM: "P",
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 0,
                        },
                        reactFrame: 'PIPS',
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Export to e-reg",
                    symbol: "trademark",
                    appCode: ["RPW"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Issues",
                            tabNumber: 0,
                        },
                        reactFrame: 'ereg',
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "LOTR",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Registrations",
                            tabNumber: 0
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                },
                {
                    label: "Web Filing",
                    appCode: ["RPWBC"],
                    navigate: {
                        component: "main",
                        url: "lfmaster.asp",
                        params: {
                            "tb": "TPAppXML",
                            "formasp": "purfileedit",
                            "id": CONST.uninitialized,
                            "PSM": CONST.uninitialized,
                        },
                        controller: {
                            tabName: "Registrations",
                            tabNumber: 1
                        },
                    },
                    addOptions: [],
                    type: MenuItemCategory.Default
                }
            ],
            addOptions: [],
            expandable: true,
            type: MenuItemCategory.Heading,
            icon: "fa-cabinet-filing",
        }

        const Registration: MenuItemType = {
            id: "reg_no_sub",
            label: "Registration",
            appCode: ["RPWNS", "RPWSK"],
            navigate: {
                        component: "main",
                        action: "PopUpRegistrationDetails"
                    },
            addOptions: [],
            type: MenuItemCategory.TopLevel,
            icon: "fa-cabinet-filing",
        }

        const NewUndertaking: MenuItemType = {
            label: "New Undertaking",
            customLabel: "Undertaking",
            navigate: {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "tb": "TPAppXML",
                    "formasp": "purfileedit",
                    "id": CONST.uninitialized,
                    "PSM": CONST.uninitialized,
                },
                reactFrame: 'undertaking',
                controller: {
                    tabName: "Undertaking",
                }
            },
            appCode: ["RPW"],
            addOptions: [],
            type: MenuItemCategory.TopLevel,
            icon: "fa-handshake",
        }

        const others: Array<MenuItemType> = [
            {
                id: "Description",
                label: "Description",
                appCode: ["RPWAB"],
                PSM: "PM",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.TopLevel,
                icon: "fa-arrow-right-arrow-left"
            },
            {
                id: "TrustLetter",
                label: "Trust Letter",
                appCode: ["RPWAB"],
                PSM: "S",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                },
                subItems: [
                    {
                        label: "Response to Trust Letter",
                        appCode: ["RPWAB"],
                        PSM: "S",
                        navigate: {
                            component: "main",
                            url: "lfmaster.asp",
                            params: {
                                "tb": "TPAppXML",
                                "formasp": "purfileedit",
                                "id": CONST.uninitialized,
                                "PSM": CONST.uninitialized,
                            },
                            controller: {
                                tabName: "Issues",
                                tabNumber: 2,
                            },
                        },
                        addOptions: [],
                        type: MenuItemCategory.Default
                    },
                ],
                addOptions: [],
                type: MenuItemCategory.Heading,
                icon: "fa-arrow-right-arrow-left"
            },
            {
                id: "TrustLetterMB",
                label: "Trust Letter",
                appCode: ["RPWMB"],
                PSM: "PSM",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.TopLevel,
                icon: "fa-arrow-right-arrow-left"
            },
            {
                id: "TrustLetterSK",
                label: "Trust Letter",
                appCode: ["RPWSK"],
                PSM: "PS",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.TopLevel,
                icon: "fa-arrow-right-arrow-left"
            },
            {
                id: "Objection",
                label: "Objection",
                appCode: ["RPWNS"],
                PSM: "PSM",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 2,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.TopLevel,
                icon: "fa-arrow-right-arrow-left"
            },
            {
                id: "TitleMemorandum",
                label: "Title Memorandum",
                appCode: ["RPW", "RPWAB"],
                PSM: "M",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Issues",
                        tabNumber: 4,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.TopLevel,
                icon: "fa-memo"
            },
        ]

        // const Insurance: MenuItemType =
        // {
        //     label: "",
        //     navigate: undefined,
        //     PSM: "PM",
        //     addOptions: [],
        //     type: MenuItemCategory.Alert,
        //     params: { variant: "primary", text: "Title Insurance is now accessed in your Workspace." }
        // };

        if (isCollege) {
            Mortgage.addOptions = Mortgage.addOptions.filter(option => option.id !== "ImportRenai" && option.label !== "Inbox & LLC" && option.label !== 'Lender Centre');
        }

        return [
            Basic,
            Contract,
            Property,
            ExtraProperty,
            Buyer,
            Seller,
            ThirdParty,
            Mortgage,
            Issues,
            Financial,
            Workspace,
            Title,
            Fire,
            Requisition,
            Undertaking,
            Registration,
            RegistrationHeading,
            NewUndertaking,
        ].concat(others);
    }
